import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';

import type { PartnerSubscriptionDetail } from './types';

type Variables = { id: number };
type Response = PartnerSubscriptionDetail;

export const useSubscription = createQuery<Response, Variables, AxiosError>({
  queryKey: ['subscriptions/partner/id'],
  fetcher: ({ id }) => {
    return client
      .get(`v2/internal/partners/subscriptions/${id}`)
      .then((response) => {
        return response.data.data;
      });
  },
});
